import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Brand } from '../../types/catalog';
import { financeCirculars } from '../../data/circulars';
import { isExpired, formatDate } from '../../utils/format';
import { CircularTable } from './CircularTable';
interface BrandCircularsProps {
  brands: Brand[];
  /** Marca elegida en el simulador; si tiene circular, se muestra esa. */
  brandId: string;
  onBrandChange: (brandId: string) => void;
}

/** Circulares oficiales por marca, visibles en el simulador antes de elegir una versión. */
export function BrandCirculars({
  brands,
  brandId,
  onBrandChange
}: BrandCircularsProps) {
  const active = financeCirculars.filter(c => !isExpired(c.validUntil));
  if (!active.length) return null;
  const current = active.find(c => c.brandId === brandId) ?? active[0];
  const nameOf = (id: string) => brands.find(b => b.id === id)?.name ?? id;
  const selectedHasNone = brandId && !active.some(c => c.brandId === brandId);
  return <section className="card p-5 sm:p-6" aria-labelledby="circulars-title" data-id="element-1018" data-mp="2ppn1lf8iceql">
      <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-1019" data-mp="2pniukofbazm3">
        <div data-id="element-1020" data-mp="2umn5bjhvx5ej">
          <h2 id="circulars-title" className="font-display text-xl font-black tracking-tight sm:text-2xl" data-id="element-1021" data-mp="2umdc7n1jmi4m">Circulares oficiales de financiación</h2>
          <p className="mt-1 text-sm text-mist" data-id="element-1022" data-mp="34ej5r17g17lx">Líneas vigentes de cada marca. Elegí modelo y versión arriba para calcular tu cuota exacta.</p>
        </div>
        <FileTextIcon className="hidden h-6 w-6 text-neon sm:block" aria-hidden data-id="element-1023" data-mp="26svib5sytzmj" />
      </div>

      {selectedHasNone && <p className="mt-4 rounded-lg bg-warn/10 px-3 py-2 text-xs text-warn" data-id="element-1024" data-mp="2goyii649bo6u">
          {nameOf(brandId)} todavía no tiene una circular cargada: se simula con sus condiciones generales.
        </p>}

      <div role="tablist" aria-label="Marca" className="mt-5 flex flex-wrap gap-2" data-id="element-1025" data-mp="3s4dhffg10q4l">
        {active.map(c => {
        const on = c.brandId === current.brandId;
        return <button key={c.brandId} role="tab" type="button" aria-selected={on} onClick={() => onBrandChange(c.brandId)} className={`rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors duration-150 ${on ? 'border-neon bg-neon/15 text-white shadow-[0_0_12px_rgba(31,168,255,0.35)]' : 'border-line text-mist hover:text-white'}`} data-id="element-1026" data-mp="1x0fgi0bkau2t">
              {nameOf(c.brandId)}
            </button>;
      })}
      </div>

      <div role="tabpanel" className="mt-5" data-id="element-1027" data-mp="19c61bh8ut4kn">
        <p className="mb-3 text-xs text-mist" data-id="element-1028" data-mp="199a09k1plzrz">
          {current.lender} · {current.reference} · Vigente hasta el {formatDate(current.validUntil)} · Cuotas con IVA, sin seguro automotor · Gestión crediticia y otorgamiento: {current.managementFeePct}% del capital financiado (promedio estimado).
        </p>
        <CircularTable circular={current} lines={current.lines} data-id="element-1029" data-mp="qklgx2ivk2ib" />
      </div>
    </section>;
}